import React, { useState } from 'react';
import { FileText } from 'lucide-react';
import { useDescriptionTemplateStore } from '../../../stores/descriptionTemplateStore';
import type { BulkUpdates } from '../../../types/bulk';
import { BulkApplyButton, BulkFieldRow, bulkSelectClass } from '../BulkFieldRow';

const CLEAR_TEMPLATE_VALUE = '__clear__';

interface BulkDescriptionTemplateFieldProps {
  onUpdate: (updates: BulkUpdates) => void;
}

export function BulkDescriptionTemplateField({ onUpdate }: BulkDescriptionTemplateFieldProps) {
  const { templates } = useDescriptionTemplateStore();
  const [templateId, setTemplateId] = useState('');

  const handleApply = () => {
    if (!templateId) return;

    if (templateId === CLEAR_TEMPLATE_VALUE) {
      onUpdate({ descriptionTemplateId: null, description: '' });
    } else {
      onUpdate({ descriptionTemplateId: templateId });
    }
    setTemplateId('');
  };

  if (templates.length === 0) {
    return (
      <BulkFieldRow
        icon={<FileText className="w-5 h-5 text-gray-500 shrink-0" />}
        label="説明テンプレートを変更"
      >
        <p className="text-sm text-gray-500 py-1">テンプレートがありません。サイドバーから作成してください。</p>
      </BulkFieldRow>
    );
  }

  return (
    <BulkFieldRow
      icon={<FileText className="w-5 h-5 text-gray-500 shrink-0" />}
      label="説明テンプレートを変更"
    >
      <select
        value={templateId}
        onChange={(e) => setTemplateId(e.target.value)}
        className={bulkSelectClass}
      >
        <option value="">選択してください</option>
        {templates.map(template => (
          <option key={template.id} value={template.id}>
            {template.name}
          </option>
        ))}
        <option value={CLEAR_TEMPLATE_VALUE}>テンプレートを解除</option>
      </select>
      <BulkApplyButton disabled={!templateId} onClick={handleApply} />
    </BulkFieldRow>
  );
}
